export const en = {
  dir: 'ltr',
  clear: 'Clear',
  yes: 'yes',
  card_title_placeholder: 'Title Place Holder',
  loading: 'Loading...',
  title: 'Title',
  no: 'no',
  cancel: 'cancel',
  ok: 'ok',
  next: 'Next',
  prev: 'Prev',
  expand: 'expand',
  entities: 'entities',
  top_entities: 'top entities',
  section: 'Section',
  name_validation_min: 'Name field must be at least 2 chars ',
  description_validation_min: 'Description field must be at least 2 chars ',
  word_validation_min: 'Word must be at least 2 chars ',
  word_validation_max: 'Word must be at most 150 chars ',
  summary_validation_min: 'summary must be at least 2 chars',
  title_validation_min: 'title must be at least 2 chars',
  title_validation_max: 'title must be at most 150 chars',
  contract: 'contract',
  hashtags: 'hashtags',
  merged: 'merged',
  Platform_source: 'Platform source',
  country: 'country',
  countries: 'countries',
  rank: 'rank',
  mentions: 'mentions',
  news_title: 'news title',
  source: 'source',
  video: 'video',
  incomplete: 'incomplete',
  platform_source: 'platform source',
  invalid_twitter: 'Invalid twitter link',
  invalid_telegram: 'Invalid telegram link',
  invalid_snapchat: 'Invalid snapchat link',
  up_to_date: 'Up to Date',
  images: 'Images',
  invalid_youtube: 'Invalid youtube link',
  invalid_facebook: 'Invalid facebook link',
  invalid_tiktok: 'Invalid tiktok link',
  you_must_enter_at_least_a_Twitter_or_youTube_link:
    'You must enter at least a Twitter or YouTube link',
  invalid_linkedin: 'Invalid linkedin link',
  invalid_instagram: 'Invalid instagram link',
  status: 'status',
  views: 'views',
  view: 'view',
  no_data: 'no data found',
  sortBy_date: 'sort ',
  facebook: 'facebook',
  twitter: 'twitter',
  instagram: 'instagram',
  youtube: 'youtube',
  all: 'All',
  influencers_table: 'Influencers Table',
  entities_table: 'Entities Table',
  top_influencers: 'Top Influencers',
  from: 'from',
  permission: 'Permission',
  to: 'to',
  items_of: 'items of',
  compare: 'compare',
  bookmark: 'bookmark',
  trashed_by: 'Trashed by',
  edit_mode_on: 'Edit mode is on',
  save: 'Save',
  summary: 'summary',
  close: 'Close',
  edit_table_columns: 'Edit table columns',
  item_view: 'item view',
  auto_scroll: 'auto scroll',
  table_view: 'table view',
  set_usage: 'Set Usage',
  language: 'language',
  archive: 'archive',
  day: 'day',
  all_time: 'all time',
  week: 'week',
  month: 'month',
  year: 'year',
  years: 'years',
  table: 'table',
  graph: 'graph',
  influencers: 'influencers',
  following: 'following',
  follow: 'Follow',
  followers: 'followers',
  last: 'last ',
  last_day: 'last day',
  select_module: 'Select A Module',
  invalid_area: 'Invalid droppable drea',
  category: 'category',
  platform: 'platform',
  trending_on: 'Trending On',
  published_on: 'Published On',
  created: 'created',
  created_on: 'created on',
  created_at: 'created on',
  created_by: 'created by',
  modified_on: 'modified on',
  modified_by: 'modified by',
  group: 'group',
  last_activity: 'last activity',
  groups: 'groups',
  Categories: 'categories',
  most_mentioned: 'Most Mentioned',
  longest_mentioned: 'Longest Mentioned',
  trending: 'trending',
  vs: 'V.S.',
  like: 'like',
  reply: 'reply',
  tweet_limit: 'post limits',
  post_type: 'post type',
  post: 'post',
  videos: 'videos',
  subscribers: 'Subscribers',
  searchBy_username: 'search by username',
  searchBy_name: 'search by name',
  searchBy_group: 'search by group',
  un_authorized:
    'This module is not available for your current plan, please update to access this module.',
  buy_now: 'Buy Now',
  name: 'Name',
  filed_downloaded: 'Hashtag Sheet Downloaded Successfully',
  searchBy_category: 'search by category',
  searchBy_videoTitle: 'search by video title',
  searchBy_topicName: 'search by topic name',
  searchBy_newsName: 'search by news name',
  searchBy_sourceName: 'search by source name',
  searchBy_hashtagName: 'search by hashtag name',
  searchBy_influencersTitle: 'search influencer',
  searchBy_division: 'search by division name',
  searchBy_tagName: 'search by tag name',
  searchBy_item: 'search by item name',
  trash: 'trash',
  search: 'search',
  search_by_set: 'Search By Name',
  unnecessary: 'unnecessary',
  regrab: 're-grab',
  sets_table: 'sets table',
  item: 'item',
  searchBy_categoriesTitle: 'search by categories title',
  sets: 'sets',
  add_new_set: 'add new set',
  edit_set: 'edit set',
  sub_cat: 'subcategory',
  search_menu: 'search menu...',
  dashboard: 'Dashboard',
  news: 'News',
  new: 'News',
  link: 'Link',
  top_mentions: 'top mentions',
  most_mentioned: 'most mentioned',
  analyzed_influencer: 'Analyzed Influencer',
  new_influencer: 'New Influencer',
  categories: 'categories',
  channels: 'Channels',
  admin: 'Admin',
  trends: 'trends',
  trending_compare: 'Tending Compare',
  Last_5_H_Trending_Hashtags: 'Last 5 H Trending Hashtags',
  Last_5_H_Trending_youtube_videos: 'Last 5 H Trending Youtube Videos',
  Last_5_H_Trending_tiktok_videos: 'Last 5 H Trending Tiktok Videos',
  total_engagement:'total engagement',
  topics: 'Topics',
  error_happened: 'Something wrong happened',
  error_grab_happened: 'Sorry , Failed To Regrab Data',
  user_module: 'user',
  users: 'Users',
  user: 'User',
  login_error: 'something wrong went while logging,please try again',
  system: 'System',
  reports: 'Reports',
  report: 'Report',
  reportedBy: 'reported by',
  bulk_action: 'Bulk Action',
  analyzed: 'analyzed',
  un_analyzed: 'un-analyzed',
  trashed: 'trashed',
  description: 'Description',
  slug: 'Slug',
  words: 'words',
  school: 'School',
  faculty: 'Faculty',
  university: 'University',
  degree: 'Degree',
  address: 'Address',
  nickname: 'Nickname',
  position: 'Position',
  workplace: 'Work Place',
  major: 'Major',
  settings: 'settings',
  details_page: 'Details page',
  assigned_hashtags: 'assigned hashtags',
  assigned_influencers: 'assigned influencers',
  assigned_entities: 'assigned entities',
  assigned_tweets: 'assigned tweets',
  assigned_instagram_posts: 'assigned instagram posts',
  assigned_youtube_posts: 'assigned youtube posts',
  assigned_tiktok_posts: 'assigned tiktok posts',
  assigned_linkedin_posts: 'assigned linkedin posts',
  popper_title: 'popper title',
  popper_description: 'popper description',
  ascending: 'Ascending',
  descending: 'Descending',
  list_view: 'list view',
  posts: 'posts',
  Export_PNG: 'Export PNG',
  Export_PDF: 'Export as PDF',
  Edit_Dashboards: 'Edit Dashboard',
  Number_of_Mentions: 'Number of Mentions',
  hashtag: 'Hashtag',
  Are_you_Sure_you_want_to_cance_the_Set: 'Are you sure you want to  cancel?',
  Are_you_Sure_you_want_to_delete_release_note:
    'Are you Sure you want to delete this release note?',
  Uploaded_videos: 'Uploaded videos',
  upload: 'Upload',
  Total_videos_plays: 'Total videos plays',
  plays: 'plays',
  back_to_home: 'BACK TO HOME',
  page_not_found: 'PAGE NOT FOUND',
  page_not_found_des:
    'The HTTP 404, 404 Not Found, and 404 error message is a Hypertext Transfer Protocol standard response code, in computer network communications, to indicate that the client was able to communicate with a given server, but the server could not find what was requested.',
  page_not_authorize:
    'The HTTP 401, 401 Not Authorize, and 401 error message is a Hypertext Transfer Protocol standard response code, in computer network communications, to indicate that the client does not have the authority to see what was requested.',

  something_went_wrong: 'Module not found: Error: Can’t reslove.',
  something_went_wrong_des:
    'The 500 Internal Server Error is a very general status code that means something has gone wrong on the web site’s server but the server could not be more specific on what the exact problem is.',
  Videos_calendar: 'Videos calendar',
  plays_per_day: 'plays per day',
  Related_Hashtags: 'Related Hashtags',
  Top_videos: 'Top videos',
  Videos_Archive: 'Videos Archive',
  grouping_table_here: 'grouping table here',
  by: 'By:',
  number_of_words: 'number-of-words',
  no_of_tweets: 'no-of-tweets',
  no_options: 'No Options',
  action: 'action',
  usage: 'usage',
  drag_here: 'Drag Here',
  username: 'Username',
  added_at: 'Added at',
  added_by: 'Added by',
  set: 'Set',
  There_Are_No_Options_Available_By_This_Name:
    'There are no options available by this name',
  No_Suggestions: 'No Suggestions',
  type_word: 'type word',
  search_by_set_name: 'search by set name',
  en: 'ENGLISH',
  ar: 'العربيه',
  Are_you_Sure_you_want_to_cancelmaking_the_Set:
    'Are you sure want to cancel making the Set?',
  Are_you_Sure_you_want_to_cancelediting_the_Set:
    '  Are you sure you want to cancel editing the Set ?',
  trending_before: 'Trending Before',
  trending_now: 'trending Now',
  restore: 'restore',
  are_you_sure_you_want_to_cancel: 'Are you sure you want to cancel?',
  are_you_sure_you_want_to_regrab: 'Are you sure you want To regrab',
  search_by_hashtag: 'search by hashtag',
  search_by_related_keyword: 'Search by Related Keyword',
  are_you_sure_you_want_to_trash:
    'Are you sure you want to trash this {{module}} / those  {{sumOfmodule}} ?',
  are_you_sure_you_want_to_hide:
    'Are you sure you want to hide this {{module}} / those  {{sumOfmodule}} ?',
  are_you_sure_you_want_to_trash_user: 'Are you sure you want to trash?',
  are_you_sure_you_want_to_unnecessary:
    'Are you sure you want to make this {{module}} / those  {{sumOfmodule}} un-necessary?',
  are_you_sure_you_want_to_trash_category:
    'Are you sure you want to trash this "{{module}}" Please note that all the "Sub-categories" Will Change to be Un-categorized',
  influencer_group: 'influencer group',
  influencer_category: 'influencer category',
  entities_category: 'entities category',
  inf_categories: 'influencer categories',
  entities_categories: 'entities categories',
  are_you_sure_you_want_to_delete:
    'Are you sure you want to permanently delete this {{module}} / those {{sumOfmodule}}?',
  are_you_sure_you_want_to_deactive:
    'Are you sure you want to deactive this {{module}} / those {{sumOfmodule}}?',
  are_you_sure_you_want_to_download:
    'Are you sure you want to download this {{module}} / those {{sumOfmodule}}?',
  are_you_sure_you_want_to_delete_user:
    'Are you sure you want to permanently delete?',
  are_you_sure_you_want_to_block:
    'Are you sure you want to block this  {{module}} / those  {{sumOfmodule}} ?',
  are_you_sure_you_want_to_unblock: 'Are you sure you want to unblock ?',
  are_you_sure_you_want_to_restore: 'Are you sure you want to restore ?',
  are_you_sure_you_want_to_merge: 'Are you sure you want to merge ?',
  merge: 'merge',
  password: 'Password*',
  confirm_password: 'Confirm password*',
  history: 'history',
  achievments: 'Achievments',
  type: 'type',
  tag: 'tag',
  not_analyzed: "This hashtag isn't analyzed ",
  not_analyzed_influencer: "This influencer isn't analyzed ",
  not_analyzed_entity: "This entity isn't analyzed ",
  number: 'Number',
  version_format_error: 'Please enter a valid version number',
  err_required: 'This field is mandatory',
  delete_success: 'deleted successfully',
  paused_success: 'paused successfully',
  actives_success: 'Activated successfully',
  active_success: 'Activated successfully',
  deactives_success: 'Deactivated successfully',
  deactive_success: 'Deactivated successfully',
  activate: 'Active',
  trash_success: 'trashed successfully',
  trash_category_success: 'trashed successfully',
  restore_success: 'restored successfully',
  regrab_success: 'regrab successfully',
  block_success: 'blocked successfully',
  unblock_success: 'Unblocked Successfully',
  unnecessary_success: 'Unnecessary done successfully',
  undo: 'undo',
  todo: 'to-do',
  add_permission: 'add to permission',
  create_report: 'create report',
  un_block: 'un-block',
  make_report: 'make report',
  block: 'block',
  reporters: 'reporters',
  re_grab: 'regrab',
  add: 'add',
  edit: 'edit',
  see_all: 'see all',
  male: 'male',
  female: 'female',
  attach_to_parent: 'attach to parent',
  account_id: 'Account ID',
  no_records_available: 'no records available',
  create: 'Create',
  search_by_inf: 'Search by influencer ',
  search_by_entity: 'Search by entity ',
  entity: 'Entity',
  text_logs: 'Logs',
  chart: 'chart',
  all_users: 'All users',
  system_inf: 'System influencers and entities',
  trending_hashtag: 'trending hashtag',
  analyze_success: 'analyze influencer successfully ',
  are_you_sure_you_want_to_un_block: 'Are you sure you want to un-block ',
  are_you_sure_you_want_to_analyze:
    'Are you sure you want to make influencer analyze ',
  nationality: 'nationality',
  number_validation_max: 'number must be at most 15 numbers',
  fax_validation_max: 'fax number must be at most 15 numbers',

  correct_url: 'Enter correct url!',
  min_err_1: 'Must be one chars at least',
  min_err_2: 'Must be two chars at least',
  max_err_255: 'Must be 255 chars at most',
  max_err_500: 'Must be 500 chars at most',
  max_err_150: 'Must be 150 chars at most',
  number_validation_min: 'number must be at least 9 numbers',
  fax_validation_min: 'fax number must be at least 10 numbers',
  number_validation_withValidation: 'Please enter valid phone number',
  num_tweets: 'No. of tweets',
  This_field_is_mandatory: 'This field is mandatory',
  trashed_on: 'Trashed On',
  channel: 'channel',
  are_you_sure_you_want_to_bookmark:
    'are you sure you want to bookmark  those  {{module}} ',
  correct_email: 'please enter valid email',
  open_in_source: 'open in source',
  influencer: 'influencer',
  err_max: '{{fieldName}} field must be at most {{length}} chars',
  err_min: '{{fieldName}} field must be at least {{length}} chars',
  err_min_items: '{{fieldName}} field must be at least {{length}} item',
  added_success: 'added successfully',
  hide_success: 'hide successfully',
  err_name_min: 'Name must be at least two letters',
  err_name_max: 'name must be at most 150 characters',
  err_address_min: 'Address must be at least two letters',
  err_address_max: 'Address must be at most 500 characters',
  entities_group: 'entities group',
  entities_groups: 'entities groups',
  hours: 'hours',
  hour: 'hours',
  one_hour: 'hour',
  o_clock: "o'clock",
  Compare: 'compare',
  delete: 'delete',
  searchBy_handle: 'search by handle',
  no_results: 'No results found',
  type_to_search: 'Type to search',
  added_on: 'added on',
  are_you_sure_you_want_to_removeLinkage:
    ' are you sure you want to remove linkage?',
  removeLinkage_success: 'remove linkage succes',
  profile: 'profile',
  edit_profile: 'edit profile',
  logout: 'logout',
  link:'link',
  Account_settings: 'Account settings',
  search_group: 'search by group name',
  search_category: 'search by category name',
  engagement_rate: 'engagement rate',
  a: 'am',
  cannot_compare: 'sorry, can not compare more than five elements',
  select: 'Select...',
  searchBy_word: 'search by word',
  search_by_country: 'Search by country',
  is_loading: 'loading...',
  This_item_cant_be_unnecessary:
    'This item can’t be unnecessary as it is analyzed before ',
  the_Selected_items_cant_be_unnecessary:
    ' the  Selected items can’t be unnecessary as one of them is Analyzed before',
  blocked_on: 'blocked on',
  must_select_one: 'You must select one at lease',
  assign_unnecessary: 'Assign to unnecessary',
  tweets: 'tweets',
  sources: 'sources',
  hashtag_posts: 'hashtag tweets',
  tiktok: 'tiktok',
  compareText: 'V.S.',
  organization: 'organization',
  organizations: 'organizations',
  by_industry: 'by industry',
  search_by_organization: 'search by organization',
  related_by_organization: 'related by organization',
  see_more: 'see more',
  see_less: 'see less',
  start_date: 'start date',
  end_date: 'end date',
  tags: 'tags',
  wrong_email: 'Email must be a valid email',
  img_notvalid_ext: 'Only JPG, PNG, or JPEG are accepted.',
  img_notvalid_size: 'Image is too big. maximum 2MB',
  img_notValid_width_or_height:
    'Image width or height is too big. maximum 1000px',
  pause: 'pause',
  active: 'active',
  inActive: 'inactive',
  analyze: 'analyze',
  author: 'author',
  bio: 'Bio',
  topic: 'topic',
  all_hashtags: 'all',
  subscribers_count: 'subscribers count',
  go_back: 'Go Back',
  yesterday: 'Yesterday',
  now: 'Now',
  about_hours: '{{time}} hours ago',
  about_hours_chart: '-{{time}} H',
  last_grabbed_on: 'last grabbed on',
  grabbed_on: 'Grabbed On',
  at: 'at',
  dayAgo: '{{day}} day Ago',
  weekAgo: '{{week}} week Ago',
  monthAgo: '{{month}} Month Ago',
  today: 'Today',
  thisWeek: 'this Week',
  thisMonth: 'this Month',
  searches: 'searches',
  count: 'count',
  in: 'in',
  main_dashboard: 'Main Dashboard',
  translation: 'translation',
  we_are_translating_more_tweets: 'we are translating more tweets...',
  we_are_translating_more_posts: 'we are translating more posts...',
  we_are_getting_more_videos: 'we are getting more videos...',
  we_are_getting_more_tweets: 'we are getting more tweets...',
  we_are_getting_more_posts: 'we are getting more posts...',
  we_are_getting_more_comments: 'we are getting more comments...',
  we_are_translating_more_comments: 'we are translating more comments...',

  other: 'other',
  mother: 'Mother',
  important: 'important',
  unimportant: 'unimportant',
  unimportant_success: 'make un important Successfully',
  important_success: 'make important Successfully',
  This_item_important: 'This item can’t be important it is important before',
  This_item_unimportant:
    'This item can’t be un important it is un important before',
  the_Selected_items_cant_be_important:
    'the  Selected items can’t be important as one of them is important before',
  the_Selected_items_cant_be_unimportant:
    'the  Selected items can’t be un important as one of them is un important before',
  the_Selected_items_important:
    'the Selected items have been added as "important" Successfully ',
  the_Selected_items_unimportant:
    'the Selected items have been added as "un important" Successfully ',
  logoutmessage: 'Are you sure you want to logout ?',
  atleastonecolumn: 'you must pick At least one column',
  atleastonechart: 'you must pick At least one chart',
  retweet: 'Re-Tweet',
  entities: 'entities',
  linked_on: 'linked on',
  user_blocked: 'This account is blocked. Please visit your admin',
  grabbed: 'grabbed',
  source_edition: 'source edition',
  source_editions: 'source editions',
  editior: 'editor',
  word: 'Word',
  thanks: 'Thanks',
  has_video: 'Has Video',
  hide: 'hide',
  error_happened_inputs: 'There is an error in the inputs',
  you_are_not_authorize: 'You are not Authorized',
  update_on: 'Updated On',
  still_retrieve_data_from_database: 'still retrieve data from database!',
  system_settings: 'settings',
  Visit_external_link: 'Visit external link',
  help: 'Help',
  frequency: 'frequency',
  num_Items: 'no. of items',
  items: 'items',
  influencers_entities: 'Influencers / Entities',
  influencers_entitie: 'Influencer / Entity',
  image_already_exists: 'This image already exists',
  mark_all_as_read: 'Mark all as read',
  notification_settings: 'Notifications settings',
  open_notifications: 'Open notifications',
  notifications: 'notifications',
  earlier: 'earlier',
  creating_your_PDF: 'Creating Your PDF',
  unlink: 'Unlink',
  view_history: ' View History',
  update_helpers: 'update helpers',
  authors: 'authors',
  editors: 'editors',
  permissions: 'permissions',
  crop: 'crop image',
  rotate: 'rotate',
  you_will_be_notified: 'you will be notified once finished',
  noFound: 'no',
  return_home: 'Sign in',
  return_sign_in: 'Return to sign in',
  trend: 'trending',
  description: 'Description',
  submit: 'Submit',
  editiors: 'editiors',
  top_tweets_in_Hashtags_module_to_group: 'Tweets to group',
  linkedin: 'linkedin',
  linkedin_posts: 'linkedin posts',
  telegram: 'Telegram',
  snapchat: 'Snapchat',
  working_on_grabbing: 'Working on grabbing',
  working_on_syncing: 'Working on syncing',
  working_on_checking: 'Working on checking',
  cant_delete_user: 'cannot delete this current user',
  platforms: 'platforms',
  cant_regrab:
    "Sorry, You Cannot Regrab Now, There's Item / Items Already In Regrabbing",
  cant_sync:
    "Sorry, You Cannot syncing Now, There's Item / Items Already In syncing",
  cant_check:
    "Sorry, You Cannot check Now, There's Item / Items Already being checked",
  default: 'Default',
  templates: 'TEMPLATES',
  likes: 'likes',
  add_another_value: 'add another value',
  add_new_release_note: 'Add new release note',
  edit_release_note: 'Edit release note',
  addItem: 'add new item',
  grabbingStatus: 'grabbing Status',
  inprogress: 'inprogress',
  in_progress: 'IN-PROGRESS',
  failed: 'failed',
  are_you_sure_you_want_to_delete_incomplete_influencer:
    'are you sure you want to delete incomplete influencer / influencers ?',
  search_by_hashtag_name: 'search by hashtag name',
  convert: 'convert',
  by_organization: 'By Organization',
  relation: 'Relation',
  relation_type: 'Relation Type',
  relation_map: 'Relation Map',
  duration: 'Duration',
  job_description: 'Job Description',
  division: 'Division',
  search_by_workplace: 'search by workplace ( organization )',
  document:'document',
  article:'article',
  mesh: 'Mesh',
  tree: 'Tree',
  file_size_is_too_large: 'upload file size must be less than 5MB',
  set_usage_hashtag: 'set hashtag usage',
  set_usage_influencer: 'set influencer usage',
  set_usage_entity: 'set entity usage',
  set_usage_tweet: 'set tweet usage',
  set_usage_youtube: 'set usage youtube',
  set_usage_instagram: 'set instagram usage',
  set_usage_tiktok: 'set tiktok usage',
  set_usage_linkedin: 'set linkedin usage',
  sentiment_status: 'sentiment status',
  email_must_be_filled: 'email must be filled',
  invalid_file_type: 'Invalid file type',
  profile_status: 'Profile status',
  the_file_limit_is_10_files_only: 'The file limit is 10 files only',
  upload_your_files_in_progress_please_wait_until_we_finish:
    'upload your files in progress please wait until we finish',
  two_hour_ago: 'two hours ago',
  hours_ago: 'hours ago',
  hour_ago: 'hour ago',
  Show_Conversations: 'Show Conversations',
  hide_Conversations: 'Hide Conversations',
  replying_to: 'Replying to',
  reply_conversation:
    'Reply conversation isn’t grabbed yet, to be able to show it you need to click the grab “reply conversation” button.',
  edit_dashboard: 'Edit Dashboard',
  done_edit: 'Edits done successfully',
  open_response: 'open response',
  open_mapping: 'open mapping',
  open_query: 'open query',
  open_settings: 'open settings',
  open_log: 'open logs',
  open_request: 'open request',
};

export const ar = {
  reply_conversation:
    'لم يتم التقاط محادثة الرد بعد، لتتمكن من إظهارها، عليك النقر فوق زر "الرد على المحادثة".',
  hide_Conversations: 'إخفاء المحادثات',
  replying_to: 'يرد علي ',
  Show_Conversations: 'إظهار المحادثات',
  hour_ago: 'منذ ساعه',
  two_hour_ago: 'منذ ساعتين',
  sentiment_status: 'تحديث الآراء',
  email_must_be_filled: 'يجب ملء البريد الإلكتروني',
  set_usage_hashtag: 'استخدام الهاشتاق للمجموعه',
  set_usage_influencer: 'استخدام المؤثر للمجموعه',
  set_usage_entity: 'استخدام الكيان للمجموعه',
  set_usage_tweet: 'استخدام التغريده للمجموعه',
  set_usage_youtube: 'استخدام اليوتيوب للمجموعه',
  set_usage_instagram: 'استخدام الانستقرام للمجموعه',
  set_usage_linkedin: 'استخدام لينكد ان للمجموعة',
  set_usage_tiktok: 'استخدام تيك توك للمجموعه',
  search_by_workplace: 'ابحث بمكان العمل ( المؤسسة )',
  division: 'شعبة',
  job_description: 'وصف الوظيفه',
  item: 'عنصر',
  duration: 'مده',
  relation_type: 'نوع الصله',
  relation: 'صله',
  relation_map: 'خريطة صلة',
  by_organization: 'بالمؤسسة',
  convert: 'تحويل',
  incomplete: 'غير مُكتمل',
  num_tweets: 'عدد التغريدات',
  search_by_hashtag_name: 'ابحث باسم الهاشتاق',
  incomplete_influencer: 'incomplete',
  incomplete_hashtags: 'incomplete',
  are_you_sure_you_want_to_delete_incomplete_influencer:
    'هل انت متأكد أنك تريد حذف المؤثر /المؤثرين قيد الجلب؟',
  failed: 'فشل',
  inprogress: 'قيد التشغيل',
  in_progress: 'قيد التشغيل',
  grabbingStatus: 'حالة الجلب',
  add_another_value: 'إضافة قيمه اخري',
  add_new_release_note: 'إضافة ملاحظة إصدار جديدة',
  edit_release_note: 'تعديل ملاحظة الإصدار',
  likes: 'الإعجابات',
  templates: 'القوالب',
  cant_regrab:
    'عذرًا ، لا يمكنك اعادة جلب البيانات الآن ، لوجود  عنصر/ عناصر قيد إعادة جلب البيانات بالفعل',
  cant_sync:
    'عذرًا ، لا يمكنك اعادة جلب البيانات الآن ، لوجود  عنصر/ عناصر قيد إعادة جلب البيانات بالفعل',
  cant_delete_user: 'لا يمكن حذف المستخدم الحالى',
  working_on_grabbing: 'جاري العمل على جلب ',
  working_on_syncing: 'جاري العمل على جلب ',
  working_on_checking: 'جاري العمل على الفحص',
  editiors: 'محررين',
  trend: 'الترند',
  noFound: 'لا يوجد',
  reporters: 'مقررين',
  rotate: 'التدوير',
  linkedin_posts: 'منشورات لينكدان',
  permissions: 'الصلاحيات',
  authors: 'كُتَّاب الرأي',
  editors: 'المحررين',
  update_helpers: ' تعديل الإرشادات ',
  view_history: ' عرض السجلات ',
  creating_your_PDF: 'جارى انشاء ملف PDF',
  earlier: 'مبكراً',
  notifications: 'الإشعارات',
  mark_all_as_read: 'حدد الكل كمقرؤه',
  notification_settings: 'إعدادات الإشعارات',
  open_notifications: 'أفتح الإشعارات',
  influencers_entities: 'المؤثرون / الكيانات',
  influencers_entitie: 'مؤثر / كيان',
  frequency: 'التكرار',
  help: 'المساعدة',
  Visit_external_link: 'قم بزيارة الرابط الخارجي',
  system_settings: 'الإعدادات',
  summary: 'ملخص',
  you_are_not_authorize: 'أنت غير مصرح',
  hide: 'إخفاء',
  has_video: 'فيديو',
  thanks: 'شكرا ',
  editior: 'محرر',
  tag: 'وسم',
  word: 'كلمة',
  source_edition: 'إصدار المصدر',
  source_editions: 'إصدارات المصدر',
  grabbed: 'تحليل أولي',
  retweet: 'إعادة تغريد',
  permission: 'إذن',
  the_Selected_items_important:
    ' تم إضافة العناصر المحدده كعناصر "مهمه" بنجاح ',
  the_Selected_items_unimportant:
    ' تم إضافة العناصر المحدده كعناصر "غير مهمه" بنجاح ',
  important: 'مهم',
  unimportant: 'غير مهم',
  unimportant_success: `تم إضافته كعنصر "غير مهم" بنجاح`,
  important_success: `تم إضافته كعنصر  "مهم" بنجاح`,
  This_item_important: 'لا يمكن أن يكون هذا العنصر  مهم لأنه تم اضافته من قبل',
  This_item_unimportant:
    'لا يمكن أن يكون هذا العنصر غير مهم لأنه تم اضافته من قبل',

  the_Selected_items_cant_be_important:
    'لا يمكن أن تكون العناصر المحددة  مهمه حيث تم إضافة أحدها من قبل',
  the_Selected_items_cant_be_unimportant:
    'لا يمكن أن تكون العناصر المحددة غير مهمه حيث تم إضافة أحدها من قبل',

  we_are_translating_more_tweets: 'نحن نترجم المزيد من التغريدات ...',
  we_are_translating_more_posts: 'نحن نترجم المزيد من المنشورات ...',
  we_are_getting_more_videos: 'نحن نجلب المزيد من الفيديوهات',
  we_are_getting_more_tweets: 'نحن نجلب المزيد من التغريدات',
  we_are_getting_more_posts: 'نحن نجلب المزيد من المنشورات',
  we_are_getting_more_comments: 'نحن نجلب المزيد من التعليقات',
  we_are_translating_more_comments: 'نحن نترجم المزيد من التعليقات ...',

  translation: 'الترجمة',
  at: 'في',
  last_grabbed_on: 'أخر تحديث',
  post_type: 'نوع المنشور',
  grabbed_on: ' تم الجلب في',
  bio: 'السيره الذاتيه',
  subscribers_count: 'عدد المشتركين',
  all_hashtags: ' الكل',
  compareText: '.V.S',
  must_select_one: 'يجب ملئ هذا الحقل بقيمة',
  This_item_cant_be_unnecessary:
    'لا يمكن أن يكون هذا العنصر غير مهم لأنه تم اضافته من قبل',
  clear: 'مسح',
  actives_success: 'تم التفعيل بنجاح',
  active_success: 'تم التفعيل بنجاح',
  the_Selected_items_cant_be_unnecessary:
    'لا يمكن أن تكون العناصر المحددة غير مهمه حيث تم إضافة أحدها من قبل',
  is_loading: 'جاري التحميل الأن...',
  merge: 'دمج',
  search_group: 'بحث بإسم المجموعة',
  search_category: 'بحث بإسم الفئة',
  removeLinkage_success: 'تم حذف الربط بنجاح',
  are_you_sure_you_want_to_removeLinkage: ' هل أنت متأكد أنك تريد حذف الربط؟',
  Are_you_Sure_you_want_to_delete_release_note:
    'هل أنت متأكد أنك تريد حذف ملاحظة الإصدار هذه؟',
  searchBy_handle: 'بحث بالفعل',
  hours: 'ساعات',
  hour: 'ساعه',
  one_hour: 'ساعه',
  o_clock: 'الساعة',
  added_success: 'تم الإضافه بنجاح',
  hide_success: 'تم الإخفاء بنجاح',
  influencer: 'المؤثر',
  trashed_on: 'تم المسح في',
  open_in_source: 'أفتح في المصدر',
  are_you_sure_you_want_to_bookmark:
    'هل انت متاكد انك تريد ادراج   {{module}} إلى قائمة المفضله',
  This_field_is_mandatory: 'هذا الحقل مطلوب',
  number_validation_max: 'رقم الهاتف لا يجب ان يتجاوز 15 رقم',
  number_validation_min: 'رقم الهاتف لا يجب ان يقل عن 9 أرقام',
  number_validation_withValidation: 'من فضلك أدخل رقم هاتف صحيح',
  fax_validation_max: 'رقم فاكس المكتب لا يجب ان يتجاوز 15 رقم',
  fax_validation_min: 'رقم فاكس المكتب لا يجب ان يقل عن 10 أرقام',
  correct_email: 'يجب ادخال بريد الكتروني صحيح',
  nationality: 'الجنسية',
  archive: 'ارشيف',
  all_users: 'كل المستخدمين',
  system_inf: 'المؤثرون في النظام والكيانات',
  account_id: 'رقم الحساب',
  make_report: 'إنشاء تقرير',
  search_by_hashtag: 'بحث بإسم الهاشتاق',
  searchBy_tagName: 'بحث عن تاج',
  are_you_sure_you_want_to_regrab: 'هل انت متأكد من إعادة المزامنه',
  are_you_sure_you_want_to_analyze: 'هل انت متأكد من تحليل المؤثر',
  add_permission: ' صلاحيات',
  password: 'كلمة المرور*',
  user_module: 'المستخدم',
  error_happened: 'حدث خطأ ما',
  error_happened_inputs: 'يوجد خطأ في المدخلات',
  error_grab_happened: ' اسف ، لا نستطيع جلب البيانات ',
  login_error: 'حدث خطأ اثناء الدخول , أعد المحاولة',
  confirm_password: 'تأكيد كلمة المرور*',
  Are_you_Sure_you_want_to_cancelmaking_the_Set:
    'هل انت متأكد انك تريد الالغاء؟',
  text_logs: 'السجلات',
  version_format_error: 'الرجاء إدخال رقم إصدار صحيح',
  word_validation_min: 'الكلمة لا يجب ان تقل عن حرفين ',
  word_validation_max: 'الكلمة لا يجب ان تزيد عن 150 حرف ',
  name_validation_min: 'الاسم لا يجب ان يقل عن حرفين ',
  summary_validation_min: 'الملخص لا يجب ان يكون اقل من حرفين',
  title_validation_min: 'العنوان لا يجب ان يكون اقل من حرفين',
  title_validation_max: 'العنوان يجب ان لا يزيد عن 150 حرف',
  description_validation_min: 'الوصف لا يجب ان يقل عن حرفين ',
  min_err_1: 'لا يجب ان يقل عن حرف',
  min_err_2: 'لا يجب ان يقل عن حرفين',
  max_err_500: 'لا يجب ان يتجاوز  500 حرف',
  max_err_255: 'لا يجب ان يتجاوز  255 حرف',
  max_err_150: 'لا يجب ان يتجاوز 150 حرف',
  correct_url: 'ادخل رابط صحيح',
  are_you_sure_you_want_to_trash:
    'هل أنت متأكد أنك تريد حذف  {{module}}/ {{sumOfmodule}} ؟',
  are_you_sure_you_want_to_hide:
    'هل أنت متأكد أنك تريد إخفاء  {{module}}/ {{sumOfmodule}} ؟',
  are_you_sure_you_want_to_trash_user: 'هل أنت متأكد أنك تريد الحذف؟',
  are_you_sure_you_want_to_trash_category:
    'هل أنت متأكد أنك تريد حذف  "{{module}}" يرجى ملاحظة أن جميع "الفئات الفرعية" ستتغير لتصبح غير مصنفة',
  are_you_sure_you_want_to_delete:
    'هل انت متأكد أنك تريد حذف  {{module}}/ {{sumOfmodule}} حذفا نهائيا ؟',
    article:'مقال',
    link:'رابط',
  are_you_sure_you_want_to_deactive:
    'هل انت متأكد أنك تريد تعطيل  {{module}}/ {{sumOfmodule}} ؟',

  are_you_sure_you_want_to_download:
    'هل انت متأكد أنك تريد تنزيل  {{module}}/ {{sumOfmodule}}  ؟',
  are_you_sure_you_want_to_delete_user: 'هل أنت متأكد أنك تريد الحذف؟',

  are_you_sure_you_want_to_cancel: 'هل أنت متأكد أنك تريد الإلغاء؟',
  are_you_sure_you_want_to_block:
    'هل أنت متأكد أنك تريد حظر هذا {{module}} / {{sumOfmodule}}؟   ',

  are_you_sure_you_want_to_unblock: 'هل أنت متأكد أنك تريد الغاء الحظر',
  are_you_sure_you_want_to_restore: 'هل أنت متأكد أنك تريد الإستعادة',
  influencer_group: 'مجموعة المؤثر',
  influencer_category: 'فئة المؤثر',
  entities_category: 'فئة الكيانات',
  search_by_related_keyword: 'بحث بالكلمات ذات صلة',
  inf_categories: 'فئات المؤثر',
  entities_categories: 'فئات الكيانات',
  restore: 'إستعادة',
  no_options: 'لا يوجد اختيارات متاحه',
  delete: 'حذف نهائي',
  top_influencers: 'أعلى المؤثرين',
  trending_now: 'ترند الان',
  trending_before: 'ترند من قبل',
  addItem: 'اضافة غرض جديد',
  are_you_sure_you_want_to_merge: 'هل أنت متأكد أنك تريد دمج المؤثر؟',
  search_by_inf: 'بحث بإسم المؤثر',
  search_by_entity: 'بحث بإسم الكيان',
  entity: 'الكيان',
  Are_you_Sure_you_want_to_cancelediting_the_Set:
    'هل أنت متأكد أنك تريد إلغاء تعديل المجموعة؟',
  Are_you_Sure_you_want_to_cancelmaking_the_Set:
    'هل أنت متأكد أنك تريد إلغاء أنشاء المجموعة؟',
  drag_here: ' إسحب هنا',
  ar: 'العربيه',
  search_by_set_name: 'بحث بإستخدام اسم المجموعة',

  type_word: 'نوع الكلمة',
  No_Suggestions: 'بدون اقتراحات',
  There_Are_No_Options_Available_By_This_Name:
    'لا توجد خيارات متاحة بهذا الاسم',
  set: 'المجموعة',
  added_at: 'مضافه في',
  added_by: 'تمت إضافة بواسطة',
  username: 'اسم المستخدم',
  usage: 'إستخدام',
  post: 'منشور',
  action: 'فعل',
  no_of_tweets: 'عدد التغريدات',
  number_of_words: 'عدد الكلمات ',
  by: 'بواسطة:',
  grouping_table_here: 'جدول التجميع هنا',
  Videos_Archive: 'أرشيف مقاطع الفيديو',
  Top_videos: 'أعلى مقاطع فيديو',
  Related_Hashtags: 'مترتبطه بالهاشتاق',
  plays_per_day: 'التشغيل يوميا',
  Videos_calendar: 'تقويم مقاطع الفيديو ',
  back_to_home: 'الرجوع للصفحة الرئيسية',
  page_not_found: 'الصفحة غير موجوده',
  page_not_found_des:
    'رسالة الخطأ 404 هي رمز استجابة قياسي لبروتوكول نقل النص التشعبي ، في اتصالات شبكة الكمبيوتر ، للإشارة إلى أن العميل كان قادرًا على الاتصال بخادم معين ، لكن الخادم لم يتمكن من العثور على ما تم طلبه.',
  page_not_authorize:
    'رسالة الخطأ 401 هي رمز استجابة قياسي لبروتوكول نقل النص التشعبي ، في اتصالات شبكة الكمبيوتر ، للإشارة إلى أن العميل ليس لديه صلاحيه في رؤية ما تم طلبه',
  something_went_wrong: 'لم يتم العثور علي الخادم :حدث خطا ',
  something_went_wrong_des:
    ' 500 خطأ داخلي في الخادم هو رمز حالة عام جدًا مما يعني حدوث خطأ ما على خادم موقع الويب ولكن لا يمكن أن يكون الخادم أكثر تحديدًا بشأن ماهية المشكلة بالضبط.  ',

  plays: 'تشغيل',
  Total_videos_plays: 'إجمالي الفيديوهات التي تم تشغيلها',
  Uploaded_videos: 'مقاطع الفيديو المُحمّلة',
  upload: 'رفع',
  Are_you_Sure_you_want_to_cancel_the_Set:
    'هل انت متأكد انك تريد اغلاق المجموعة؟',
  hashtag: 'هاشتاق',
  Number_of_Mentions: 'عدد الإشارات',
  Edit_Dashboards: 'تعديل القائمة الرئيسية',
  Export_PNG: 'تنزيل الصورة',
  Export_PDF: 'تصدير بصيغة PDF',
  descending: 'تنازلي',
  list_view: 'قائمة',
  ascending: 'تصاعدي',
  en: 'English',
  ar: 'العربيه',
  popper_description: 'وصف بوبر',
  popper_title: 'عنوان بوبر',
  assigned_hashtags: ' الهاشتاقات المُرتبطة',
  assigned_influencers: ' المؤثرون المُرتبطة',
  assigned_entities: ' الكيانات المُرتبطة',
  assigned_tweets: 'التغريدات المُرتبطة ',
  assigned_instagram_posts: 'منشورات الانستقرام المُرتبطة',
  assigned_youtube_posts: 'منشورات اليوتيوب المُرتبطة',
  assigned_tiktok_posts: 'منشورات تيك توك المُرتبطة',
  assigned_linkedin_posts: 'منشورات لينكدان المُرتبطة',
  school: 'مدرسه',
  university: 'جامعة',
  faculty: 'كلية',
  degree: 'الدرجة',
  workplace: 'مكان العمل',
  address: 'العنوان',
  nickname: 'الاسم المستعار',
  position: 'المنصب',
  major: 'القسم الرئيسي',
  words: 'كلمات',
  slug: 'اسم المفتاح',
  status: 'الحالة',
  trending_hashtag: 'الهاشتاقات الأكثر تداولآ',
  unnecessary: 'غير مهم',
  trashed: 'محذوفات',
  trash: 'حذف',
  un_analyzed: 'غير محلل',
  bulk_action: 'جمله الاجراءات',
  reports: 'تقارير',
  report: 'تقرير',
  system: 'النظام',
  user: 'المستخدم',
  users: 'المستخدمون ',
  topics: 'الموضوعات',
  Last_5_H_Trending_Hashtags: 'اخر 5 ساعات هاشتاقات ترند',
  Last_5_H_Trending_youtube_videos: 'اخر 5 ساعات فيديوهات يوتيوب ترند',
  Last_5_H_Trending_tiiktok_videos: 'اخر 5 ساعات فيديوهات تيك توك ترند',
  trending_compare: 'مقارنة الترندات',
  trends: 'الترندات',
  admin: 'المشرف',
  channels: 'القنوات',
  settings: 'الإعدادات',
  chart: 'رسم بياني',
  categories: 'الفئات',
  new_influencer: 'المؤثر الجديد',
  analyzed_influencer: 'المؤثر المحلل',
  analyzed: 'تحليل كامل',
  sets: 'مجموعات',
  most_mentioned: 'الأكثر إشارة',
  top_mentions: 'أعلى إشارة',
  link: 'رابط',
  unlink: 'الغاء الربط',
  activate: 'تفعيل',
  news: 'الأخبار',
  new: 'الخبر',
  dashboard: 'قائمة رئيسية',
  search_menu: 'قائمة البحث...',
  sets_table: 'جدول المجموعات',
  card_title_placeholder: 'عنوان المحتوي',
  set_usage: 'إستخدام المجموعة',
  sub_cat: 'تصنيف فرعي',
  search_by_set: 'بحث بالإسم',
  created: 'تم إنشاؤها',
  loading: 'يتم التحميل الآن',
  dir: 'rtl',
  yes: 'نعم',
  posts: 'منشورات',
  details_page: 'صفحة التفاصيل',
  merged: 'مدمج',
  no: 'لا',
  cancel: 'إلغاء',
  ok: 'حسناً',
  rank: 'الرتبة',
  next: 'التالي',
  prev: 'السابق',
  expand: 'مدد',
  mother: 'مؤسسات أم',
  contract: 'تقلص',
  all_time: 'كل الأوقات ',
  hashtags: 'الهاشتاقات',
  Platform_source: ' المصدر',
  country: 'الدولة',
  countries: 'الدول',
  mentions: 'الإشارات',
  news_title: 'عنوان الخبر',
  source: 'مصدر',
  video: 'الفيديو',
  tiktok: 'تيك توك',
  up_to_date: 'حديث',
  images: 'الصور',
  invalid_twitter: 'يجب إدخال رابط تويتر صحيح',
  invalid_telegram: 'يجب إدخال رابط تيليجرام صحيح',
  invalid_snapchat: 'يجب إدخال رابط سناب شات صحيح',
  invalid_youtube: 'يجب إدخال رابط يوتيوب صحيح',
  invalid_facebook: 'يجب إدخال رابط فيس بوك صحيح',
  invalid_tiktok: 'يجب إدخال رابط تيك توك صحيح',
  invalid_linkedin: 'يجب إدخال رابط لينكدان صحيح',
  invalid_instagram: 'يجب إدخال رابط انستقرام صحيح',
  platform_source: 'المصدر',
  trending_on: 'ترند في',
  published_on: 'نشر في',
  views: 'المشاهدات',
  no_data: 'لا يوجد بيانات',
  sortBy_date: 'رتب',
  facebook: 'فيس بوك',
  twitter: 'تويتر',
  instagram: 'انستقرام',
  all: 'الكل',
  from: 'من',
  to: 'إلى',
  items: 'عناصر',
  items_of: 'عناصر من',
  num_Items: 'عدد العناصر',
  compare: 'قارن',
  bookmark: 'حفظ',
  trashed_by: 'مٌسح بواسطة',
  edit_mode_on: 'وضع التعديل مفعل',
  save: 'حفظ',
  close: 'اغلاق',
  edit_table_columns: 'تعديل أعمدة الجدول',
  item_view: 'عرض العناصر',
  auto_scroll: 'التمرير الذاتي',
  table_view: 'عرض الجدول',
  language: 'اللغة',
  day: 'يوم',
  week: 'أسبوع',
  unnecessary: 'غير مهم',
  section: 'القسم',
  top_entities: 'أهم الكيانات',
  month: 'شهر',
  year: 'سنة',
  years: 'سنة',
  graph: 'رسم بياني',
  table: 'جدول',
  influencers: 'المؤثرون',
  following: 'المُتابَعين',
  followers: 'المُتابِعين',
  select_module: 'اختر فرع',
  follow: 'يتابع',
  last: ' اخر',
  last_day: 'اخر يوم',
  category: 'الفئة',
  platform: 'المنصة',
  platforms: 'المنصات',
  created_on: 'تم الإنشاء  في',
  created_at: 'تم الإنشاء  في',
  created_by: 'تم الإنشاء بواسطة',
  modified_on: 'تم التعديل في',
  modified_by: 'تم التعديل بواسطة',
  group: 'المجموعة',
  last_activity: 'اخر نشاط',
  groups: 'المجموعات',
  Categories: 'الفئات',
  most_mentioned: 'الأكثر إشارة',
  longest_mentioned: 'الأطول إشارة',
  description: 'الوصف',
  attach_to_parent: ' إلحاق بالفئه الأساسية',
  trending: 'الترندات',
  un_authorized:
    'هذا المديول غير متاح طبقآ لخطتك الحاليه. يرجي شراء هذا النموذج ',
  buy_now: 'إشتري الآن',
  name: 'الإسم',
  vs: 'ضد',
  like: 'الاعجاب',
  reply: 'الرد',
  tweet_limit: 'عدد البوستات ',
  videos: 'الفيديوهات',
  subscribers: 'المشتركون',
  searchBy_username: 'بحث بإسم المستخدم',
  searchBy_name: 'بحث بالاسم ',
  searchBy_group: 'بحث بالمجموعة',
  searchBy_category: 'بحث بالفئة',
  filed_downloaded: 'تم تحميل الملف بنجاح',
  invalid_area: 'منطقة اسقاط غير صالحة',
  searchBy_newsName: 'بحث بإسم الخبر',
  searchBy_videoTitle: 'بحث بعنوان الفيديو',
  searchBy_topicName: 'بحث بإسم الموضوع',
  searchBy_sourceName: 'بحث بإسم المصدر',
  searchBy_hashtagName: 'بحث بإسم الهاشتاق',
  searchBy_influencersTitle: 'بحث بإسم المؤثر',
  searchBy_categoriesTitle: 'بحث بإسم الفئة',
  searchBy_division: 'بحث بإسم الشعبة',
  searchBy_item: 'بحث بإسم العنصر',
  sets: 'مجموعات',
  add_new_set: 'إضافة مجموعة جديدة',
  edit_set: 'تعديل مجموعة',
  editor: 'المحرر',
  regrab: 'إعادة مزامنه',
  add_permission: 'إضافة إلى اذن',
  history: 'السجلات',
  achievments: 'الانجازات',
  type: 'النوع',
  number: 'الرقم',
  err_required: 'هذا الحقل مطلوب',
  not_analyzed: 'الهاشتاق غير محلل ',
  not_analyzed_influencer: 'المؤثر غير محلل ',
  not_analyzed_entity: 'الكيان غير محلل ',
  delete_success: 'تم الحذف بنجاح',
  paused_success: 'تم الايقاف  بنجاح',
  deactives_success: 'تم التعطيل  بنجاح',
  deactive_success: 'تم التعطيل  بنجاح',
  analyze_success: 'تم تحليل المؤثر  بنجاح',
  trash_success: 'تم الحذف بنجاح',
  trash_category_success: 'تم الحذف بنجاح',

  restore_success: 'تمت الإستعادة بنجاح',
  regrab_success: 'تمت إعادة الجلب بنجاح',
  block_success: 'تمت  الحظر بنجاح',
  unblock_success: 'تمت إلغاء الحظر بنجاح',
  unnecessary_success: 'غير مهم بنجاح',
  undo: 'الغاء',
  todo: 'المهام',
  create_report: 'أنشاء تقرير',
  un_block: 'الغاء الحظر',
  block: 'حظر',
  re_grab: 'إعادة المزامنة',
  add: 'إضافة',
  edit: 'تعديل',
  see_all: 'اظهار الكل',
  male: 'ذكر',
  female: 'انثى',
  influencers_table: 'جدول المؤثرين',
  entities_table: 'جدول الكيانات',
  no_records_available: 'لا يوجد بيانات',
  Compare: 'مقارنة',
  create: 'أضف',
  channel: 'قناة',
  are_you_sure_you_want_to_unnecessary:
    'هل آنت متأكد انك تريد جعل هذا {{module}} / {{sumOfmodule}} غير مهم ؟',
  documnet:'مستند',  
  err_max: 'يجب ألا يزيد {{fieldName}} عن {{length}} حرف',
  err_min: 'يجب ألا يقل {{fieldName}} عن {{length}} حرف',
  err_min_items: 'يجب ألا يقل {{fieldName}} عن {{length}} عنصر',
  total_engagement:'كل التفاعلات',
  crop: 'قص الصوره',
  entities: 'الكيانات',
  entities_table: 'جدول الكيانات ',
  entities_group: 'مجموعة الكيانات',
  entities_groups: 'مجموعات الكيانات',
  err_name_min: 'الاسم يجب ألا يقل عن حرفين',
  err_name_max: 'الإسم يجب ان لا يتجاوز 150 حرف',
  err_address_min: 'العنوان يجب ألا يقل عن حرفين',
  err_address_max: 'العنوان يجب ان لا يتجاوز 500 حرف',
  search: 'إبحث',
  no_results: 'لا يوجد نتائج',
  type_to_search: 'أكتب للبحث',
  added_on: 'مضافة في',
  profile: 'حسابي',
  edit_profile: 'تعديل حسابي',
  logout: 'الخروج',
  view: 'عرض',
  Account_settings: 'اعدادات الحساب',
  engagement_rate: 'معدل التفاعلات',
  a: 'صباحا',
  cannot_compare: 'عذرا لا يمكن مقارنة أكثر من خمس عناصر',
  select: 'اختار...',
  searchBy_word: 'بحث بالكلمة',
  search_by_country: 'بحث بإسم الدولة',
  blocked_on: 'تم حظره في',
  assign_unnecessary: 'تعيين لغير مهم',
  youtube: 'يوتيوب',
  sources: 'مصادر',
  tweets: 'تغريدات',
  sources: 'المصادر',
  hashtag_posts: ' التغريدات',
  organization: 'المؤسسة',
  organizations: 'المؤسسات',
  by_industry: 'حسب الصناعة',
  search_by_organization: 'بحث بالمؤسسة',
  related_by_organization: 'ذو صله بالمؤسسة',
  see_more: 'عرض المزيد',
  see_less: 'عرض القليل',
  start_date: 'تاريخ البدء',
  end_date: 'تاريخ الانتهاء',
  tags: 'الوسوم',
  wrong_email: 'ادخل بريد الكتروني صالح',
  img_notvalid_ext: 'فقط JPG و PNG و JPEG يتم قبول',
  img_notvalid_size: 'حجم الصورة كبير. الحجم المسوم بحد اقصى ٢ مبجا بايت',
  img_notValid_width_or_height:
    'عرض او ارتفاع الصورة كبير الحد الاقصي 1000 بكسل',
  pause: 'ايقاف',
  active: 'تفعيل',
  inActive: 'غير مفعل',
  analyze: 'تحليل',
  author: 'مؤلف',
  topic: 'موضوع',
  go_back: 'الرجوع للخلف',
  yesterday: 'الامس',
  now: 'الآن',
  about_hours: 'منذ {{time}} ساعة',
  about_hours_chart: '-{{time}} ساعه',
  today: 'اليوم',
  thisWeek: 'هذا الأسبوع',
  thisMonth: 'هذا الشهر',
  dayAgo: 'منذ {{day}} يوم',
  weekAgo: 'منذ {{week}} أسبوع',
  monthAgo: 'منذ {{month}} شهر',
  searches: 'عمليات البحث',
  count: 'العدد',
  in: 'في',
  main_dashboard: 'القائمة الرئيسية',
  other: 'اخرى',
  logoutmessage: ' هل أنت متأكد أنك تريد  تسجيل الخروج ؟',
  atleastonecolumn: 'يجب اختيار عمود واحد علي الاقل',
  atleastonechart: '  يجب اختيار رسم توضيحى واحد على الأقل ',
  linked_on: 'تم الربط في',
  user_blocked: 'تم حظر هذا الحساب يرجى زيارة المسؤول الخاص بك',
  update_on: ' اخر تحديث',
  still_retrieve_data_from_database: 'جارى استرجاع البيانات!',
  image_already_exists: 'هذه الصورة موجودة بالفعل',
  title: 'العنوان',
  you_will_be_notified: 'سوف يتم اخطارك عند الانتهاء',
  return_home: 'تسجيل الدخول',
  return_sign_in: 'الرجوع لتسجيل الدخول',
  description: 'الوصف',
  submit: 'حفظ',
  top_tweets_in_Hashtags_module_to_group: 'التغريدات إلى المجموعة',
  linkedin: 'لينكدان',
  telegram: 'تيليجرام',
  snapchat: 'سناب شات',
  you_must_enter_at_least_a_Twitter_or_youTube_link:
    'يجب عليك إدخال رابط تويتر أو يوتيوب على الأقل',
  default: 'افتراضي',
  mesh: 'شبكة',
  tree: 'شجرة',
  file_size_is_too_large: 'يجب ان يكون حجم الملف اقل من 5 ميغا بايت',
  invalid_file_type: 'نوع الملف غير صالح',
  profile_status: 'حالة الملف الشخصي',
  the_file_limit_is_10_files_only: 'الحد الأقصى للملف هو 10 ملفات فقط',
  upload_your_files_in_progress_please_wait_until_we_finish:
    'جارى تحميل الملفات برجاء الإنتظار حتى ينتهى التحميل',
  edit_dashboard: 'تحرير القائمة الرئيسية',
  done_edit: 'تم التعديل بنجاح',
};
